import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useEffect, useState } from 'react';
import logger from '../../services/LocalServer/logger';
import { useTranslation } from 'react-i18next';

const IdleTimer = (props) => {
  const { t } = useTranslation();
  const { idle } = props;
  const [play, setPlay] = useState(false);
  const machineID = localStorage.getItem('machineID');
  const timeout = props.machine?.time_to_idle ? props.machine.time_to_idle * 1000 : 60000;
  let history = useHistory();
  const handleOnIdle = (event) => {
    setPlay(false);
    // if (props.machine?.screenSaver) {
    logger(2, 'idle timeout');
    history.push(`/machineUI/slider/${machineID}`);
    // }
  };

  const handleOnIdle1 = (event) => {
    console.log('start countdown');
    setPlay(true);
  };

  const handleOnActive1 = (event) => {
    setTimeout(() => {
      setPlay(false);
    }, 100);
  };

  const handleOnAction1 = (event) => {
    setTimeout(() => {
      setPlay(false);
    }, 100);
  };

  const idletimer = useIdleTimer({
    timeout: process.env.REACT_APP_DEV === 'TRUE' ? 60000000 : timeout,
    onIdle: handleOnIdle,
    // onActive: handleOnActive,
    // onAction: handleOnAction,
    debounce: 500,
  });

  const idletimer1 = useIdleTimer({
    timeout: process.env.REACT_APP_DEV === 'TRUE' ? 60000000 : timeout - 15000,
    // timeout: 3000,
    onIdle: handleOnIdle1,
    onActive: handleOnActive1,
    onAction: handleOnAction1,
    debounce: 500,
  });

  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return;
    }

    return (
      <div className="countdowntext">
        <div>{t(`Timeout In`)}</div>
        <div>{remainingTime}</div>
        <div>{t(`Seconds`)}</div>
      </div>
    );
  };

  useEffect(() => {
    idletimer.reset();
    idletimer1.reset();
  }, [idle]);

  useEffect(() => {
    const timeoutId = document.querySelector('#timeoutId');
    if (timeoutId)
      timeoutId.addEventListener('click', (event) => {
        event.preventDefault();
      });
  }, [play]);

  if (!play) {
    return null;
  } else {
    return (
      <div className="privacy-modal-container" id="timeoutId">
        <div className="countdown">
          <CountdownCircleTimer
            isPlaying={play}
            size={600}
            duration={15}
            strokeWidth={20}
            colors={['#004777', '#F7B801', '#A30000', '#A30000']}
            colorsTime={[10, 6, 3, 0]}
          >
            {renderTime}
          </CountdownCircleTimer>
        </div>
      </div>
    );
  }
};

export default IdleTimer;
